import PropTypes from '../_util/vue-types';
import { computed, nextTick, onBeforeUnmount, ref, watch } from 'vue';
import { defineComponent } from 'vue';
import ResizeObserver from '../vc-resize-observer/index';
export const VcArrowProps = () => ({
    prefixCls: String,
    disabled: { type: Boolean, default: false },
    status: String,
    stepNumber: Number,
    arrowIndex: Number,
    type: {
        type: String,
        default: 'arrow',
    },
    title: PropTypes.any,
    scroll: { type: Boolean, default: false },
    auto: { type: Boolean, default: false },
    onDblclick: Function,
    onStepClick: Function,
});
export default defineComponent({
    name: 'Arrow',
    props: VcArrowProps(),
    slots: ['title', 'StepIcon'],
    emits: ['dblclick', 'stepClick'],
    setup(props, { slots, emit, expose }) {
        const arrow = ref();
        const onItemClick = e => {
            if (props.disabled) {
                return;
            }
            emit('dblclick', e);
            emit('stepClick', props.arrowIndex);
        };
        const arrowWidth = ref('auto');
        const onResize = ({ width }) => {
            nextTick(() => {
                arrowWidth.value = `${width}px`;
            });
        };
        const styleWidth = computed(() => {
            if (!props.scroll && props.auto) {
                return '100%';
            }
            else {
                return arrowWidth.value;
            }
        });
        const arrowHover = ref(false);
        const setHover = () => {
            arrowHover.value = true;
        };
        const setNotHover = () => {
            arrowHover.value = false;
        };
        expose({
            isHover: arrowHover,
        });
        const stopWatch = watch([arrow, () => props.disabled], ([v, v1]) => {
            if (v) {
                if (!v1) {
                    v.addEventListener('mouseenter', setHover);
                    v.addEventListener('mouseleave', setNotHover);
                }
                else {
                    v.removeEventListener('mouseenter', setHover);
                    v.removeEventListener('mouseleave', setNotHover);
                }
            }
        }, { immediate: true, flush: 'post' });
        onBeforeUnmount(() => {
            stopWatch();
            arrow.value.removeEventListener('mouseenter', setHover);
            arrow.value.removeEventListener('mouseleave', setNotHover);
        });
        return () => {
            const { prefixCls, status = 'wait', disabled, type, title = slots.title?.() } = props;
            const mergeClass = {
                [`${prefixCls}-item-${type}`]: true,
                [`${prefixCls}-item-${type}-${status}-title`]: true,
                [`${prefixCls}-item-${type}-${status}`]: type !== 'no-arrow',
                [`${prefixCls}-item-${type}-${status}-disabled`]: disabled && type !== 'no-arrow',
            };
            return (<div ref={arrow} class={mergeClass} onDblclick={onItemClick}>
          <ResizeObserver onResize={onResize}>
            <div style={{ width: styleWidth.value, maxWidth: '260px', minWidth: '90px' }} class={`${prefixCls}-arrow-item-title`}>
              {title}
            </div>
          </ResizeObserver>
        </div>);
        };
    },
});
